<template>
    <div class="accountrecorder" name="accountrecorder">
      <topNav :title="title"></topNav>
      <div class="searchbox">
        <div class="daterange">
          <div class="daterange_label">选择日期区间</div>
          <div class="daterange_value" @click="fnShowDatePicker">{{ startDate ? startDate + "~" + endDate : ''}}</div>
          <van-calendar
          v-model="showDatePicker"
          :default-date="defaultDateRange"
          :max-range="31"
          type="range"
          color="#4687f8"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="handleSelectDateRange" />
        </div>
      </div>
      <div class="list list_invoice">
          <div class="total_box" v-if="parkingPayRecordList.length !== 0 && loadingRecord == false">
              <div class="checkall_box" @click="checkAll()">
                <div :class="['icon icon_checkbox', {'icon_checked': isCheckedAll}]"></div>
                <span class="txt">全选</span>
              </div>
              <div :class="['cus_button', {'loading': loadingInvoice }]" @click.stop="applicationInvoice()">
                <van-loading v-if="loadingInvoice" size="12px" color="#337ff5" />
                <span>批量开票</span>
              </div>
          </div>
          <div class="no_record" v-show="parkingPayRecordList.length == 0 && loadingRecord == false">
            <img src="../../../../static/images/pic_nopaymentlist.png" alt="">
            <p class="tips">暂无缴费记录</p>
            <div class="empty_tip_module">
              <p>可以往【扫码支付开票】查询开票</p>
              <p>如果还是未查询到，可能是以下原因：</p>
              <p>1.您的订单不在查询时间区间内</p>
            </div>
          </div>
          <div class="sectionCount" v-for="(item,index) in parkingPayRecordList" :key="index" @click="recorderdetail(item)">
            <div class="check_box">
              <div :class="['icon icon_checkbox', {'icon_checked': item.isChecked, 'disabled': item.invoiceStatus == '1'}]" @click.stop="changeChecked(item)"></div>
            </div>
            <div class="payrecordinfo">
              <h5>{{item.parkingName + '(' + caculateScen(item) + ')'}}</h5>
              <p>{{'缴费时间：' + item.payTime}}</p>
            </div>
            <div class="extra">
              <p>￥<span>{{item.payPrice }}</span></p>
              <div :class="['cus_button', {'loading': item.isLoading}]" v-if="item.invoiceEnable && item.invoiceStatus == '0'" @click.stop="applicationInvoice(item)">
                <van-loading v-if="item.isLoading" size="12px" color="#337ff5" />
                <span>开票</span>
              </div>
              <div :class="['cus_button', {'primary': item.invoiceStatus == '1'}]" v-if="item.invoiceEnable && item.invoiceStatus == '1'">已开票</div>
            </div>
          </div>
      </div>
    </div>

</template>
<script>
import topNav from "../../topnav/topnav"
import {DETAIL as API} from "@/assets/api"
import { Loading, Calendar } from 'vant';
import dayjs from 'dayjs'

export default {
  name: 'parkingPayRecord',
  components:{
     topNav,
     [Calendar.name]: Calendar,
  },
  data() {
    return {
      title:"电子发票",

      showDatePicker: false,
      maxDate: null,
      minDate: null,
      defaultDateRange: [],
      startDate: '',
      endDate: '',

      paymentScenarioList: [
        {label: '临停缴费', value: "TEMPPARKING"},
        {label: '临停缴费', value: "TEMPPARKING_AI"},
        {label: '套餐充值', value: "RECHARGE"},
      ],

      requestParams: null,

      loadingRecord: false,
      parkingPayRecordList: [],
      isCheckedAll: false,
      loadingInvoice: false,
      isHZ:0,
    }
  },
  created(){
      this.isHZ = this.$route.query.isHZ? this.$route.query.isHZ : 0
      this.setOptionalDateRange()
      this.setDateRange()
      this.setDefDateRange()
      this.requestParams = this.$route.query
      this.getParkingPayRecord(this.requestParams)
  },
  watch:{
    parkingPayRecordList: {
      handler(arr){
        if(!arr.filter(i=>i.isChecked).length || !arr.filter(i=>!i.isChecked).length){
          this.isCheckedAll = arr.filter(i=>i.isChecked).length > 0 ? true : false
        }
      },
      deep: true
    }
  },
  methods:{
    setOptionalDateRange(){
      this.minDate = new Date(dayjs().subtract('3', 'month').add('1', 'day').format())
      this.maxDate = new Date(dayjs().format())
    },
    fnShowDatePicker(){
      this.showDatePicker = true
      this.setDateRange()
    },
    setDateRange(date){
      this.startDate = date ? dayjs(date[0]).format('YYYY-MM-DD') : dayjs().subtract('1', 'month').add('1', 'day').format('YYYY-MM-DD')
      if(this.isHZ){
        const minStartDate = '2025-07-24'
        if (this.startDate < minStartDate) {
          this.startDate = minStartDate
        }
      }
      this.endDate = date ? dayjs(date[1]).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD')
    },
    setDefDateRange(){
      this.defaultDateRange = [new Date(this.startDate), new Date(this.endDate)]
    },
    handleSelectDateRange(date){
      this.showDatePicker = false
      this.setDateRange(date)
      this.getParkingPayRecord(this.requestParams)
    },
    caculateScen(item){
      let arr = this.paymentScenarioList.filter(i=>i.value == item.paymentScenario)
      return arr.length > 0 ? arr[0].label : ''
    },
    recorderdetail:function(item){
      this.$router.push({
        name: 'informdetail2',
        query: {
          "merchant": item.merchant,//商户名称
          "carNumber": item.carNumber,//车牌号
          'payAmount': item.payPrice,//支付金额
          'parkingName': item.parkingName,//停车场
          // 'totalTime': item.parkTotalTime,//停车总时长
          'payChannelName': item.payChannelName,//支付方式
          'carInDate': item.payTime,//缴费时间
          'orderNo': item.outTradeNo,//订单号
          // 'outOrderNo': item.outOrderNo,//第三方订单号
          // 'payState': item.paymentStatus,//支付状态
          // 'invoiceEnable': item.invoiceEnable, //是否显示开具发票按钮

        }
      })
    },
    getParkingPayRecord(item){
      this.title = item.parkingname?item.parkingname:'电子发票'
      if(!this.startDate || !this.endDate){
        this.Toast('请选择选择日期区间')
        return
      }
      
      var req = {
        carNum: item.carNum,
        commid: item.commid,
        parkingno: item.parkingno,
        appid: item.appid,
        startDate: this.startDate,
        endDate: this.endDate,
      }
      
      this.loadingRecord = true
      this.$http({
          method: 'post',
          url: API.GET_PARK_PAYRECORD,
          data: req,
          success: function(res){
            if(res.code == 500){
              this.Toast(res.msg)
              this.loadingRecord = false
              return
            }
            if(res.data && res.data.length > 0){
              this.parkingPayRecordList = res.data
            }
            this.loadingRecord = false
          }.bind(this),
          error: function(error){
            this.loadingRecord = false
          }
      })
    },
    applicationInvoice(item){
      let _query = {
        carNum: this.$route.query.carNum,
        commid: this.$route.query.commid,
        parkingno: this.$route.query.parkingno,
        appid: this.$route.query.appid,
        isYPY: 1,
        isHZ:this.isHZ,
      }
      if(item){
        _query.orders = item.orderNum + '_' + item.paymentScenario
      }else{
        _query.orders = this.parkingPayRecordList.filter(i=>i.isChecked).map(j=>j.orderNum + '_' + j.paymentScenario).join()
      }

      this.$router.push({name: 'invoice', query: _query })
    },
    changeChecked(item){
      if(item.invoiceStatus == '1') return
      let isChecked = !item.isChecked
      this.$set(item, 'isChecked', isChecked)
    },
    checkAll(){
      this.isCheckedAll = !this.isCheckedAll
      this.parkingPayRecordList = this.parkingPayRecordList.map(i=>{
        i.isChecked = i.invoiceStatus == '0' ? this.isCheckedAll : false
        return i
      })
    },
  },
}
</script>
<style lang="less" scoped>
  .accountrecorder{
    min-height: 100vh;
    border-bottom:1px solid #fff; 
    background-color: #fff;
    box-sizing: border-box;
  }

  .parkingname{
    font-size: 17px;
    line-height: 32px;
  }

  .icon_checkbox{
    display: inline-block;
    vertical-align: middle;
    width: 14px;
    height: 14px;
    background: url('../../../../static/images/icon_checkbox.png') center no-repeat;
    background-size: 100%;
    &.icon_checked{
      background: url('../../../../static/images/icon_checkbox_checked.png') center no-repeat;
      background-size: 100%;
    }
    &.disabled{
      filter: grayscale(100%);
    }
  }

  .cus_button{
      background-color: #fff;
      float: right;
      border-radius: 12px;
      border: solid 1px #337ff5;
      font-size: 13px;
      color: #337ff5;
      padding: 5px 12px;
      display: flex;
      &.primary{
        border: solid 1px #07c160;
        color: #07c160;
      }
  }

  .sectionmonth, .list_invoice{
    padding-bottom: 10px;
    .no_record{
      img{
        width: 148px;
        height: 91px;
        margin-top: 60px;
        padding-left: 20px;
        &:before{
          content: "";
          display: block;
          width: 2px;
          height: 2px;
          border-radius: 50%;
          background-color: #458af6;
        }
      }
      .tips{
        font-size: 14px;
        color: rgb(154,154,154);
        line-height: 30px;
        padding-left: 20px;
        text-align: center;
        &:before{
          content: "";
          display: block;
          width: 2px;
          height: 2px;
          border-radius: 50%;
          background-color: #fff;
        }
      }
    }
    .sectionCount{
      box-sizing: border-box;
      background: #fff;
      width: 94%;
      height: 80px;
      background-color: #ffffff;
      box-shadow: 0px 0px 19px 1px rgba(137, 154, 173, 0.15);
      border-radius: 15px;
      margin: 10px auto 0;
      padding: 12px;
      display: flex;
      .check_box{
        display: flex;
        align-items: center;
      }
      .payrecordinfo{
        text-align: left;
        width: 75%;
        h5{
            font-size: 14px;
            color: #666666;
            margin-bottom: 10px;
            margin-top: 12px;
            &:before {
              content: "";
              display: inline-block;
              vertical-align: middle;
              width: 4px;
              height: 4px;
              background-color: #458af6;
              border-radius: 50%;
              margin-right: 5px;
            }
        }
        p{
            font-size: 9px;
            color: #999999;
            &:before {
              content: "";
              display: inline-block;
              vertical-align: middle;
              width: 4px;
              height: 4px;
              background-color: #05c192;
              border-radius: 50%;
              margin-right: 5px;
            }
        }
      }
      .extra{
        width: 25%;
        text-align: right;
        p{
            font-size: 9px;
            font-weight: bold;
            line-height: 30px;
            letter-spacing: 1px;
            color: #337ff5;
            span{
              font-size: 18px;
              vertical-align: middle;
            }
        }
      }
    }
    .loadmore{
      margin: 0 auto;
    }
  }
  
  .list_invoice{
    .check_box{
      width: 8%;
    }
    .payrecordinfo{
      width: 72%;
    }
    .total_box{
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 92%;
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
      .checkall_box{
        display: flex;
        align-items: center;
        .txt{
          margin-left: 5px;
          font-size: 14px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
  
  .empty_tip_module{
    margin-top: 30px;
    line-height: 32px;
    h5{
      font-weight: bold;
      color: #666;
      font-size: 14px;
    }
    p{
      font-size: 12px;
      color: #999;
    }
  }
  .searchbox{
    padding: 10px 0;
  }
  .daterange{
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    &_label{
      flex: none;
      box-sizing: border-box;
      width: 6.2em;
      margin-right: 12px;
      color: #646566;
      text-align: left;
      word-wrap: break-word;
    }
    &_value{
      position: relative;
      overflow: hidden;
      color: #969799;
      text-align: right;
      vertical-align: middle;
      word-wrap: break-word;
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/electronicInvoice/parkingPayRecord.vue